/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import {
  BookmarkAltIcon,
  BriefcaseIcon,
  ChartBarIcon,
  CheckCircleIcon,
  CursorClickIcon,
  DesktopComputerIcon,
  GlobeAltIcon,
  InformationCircleIcon,
  MenuIcon,
  NewspaperIcon,
  OfficeBuildingIcon,
  PhoneIcon,
  PlayIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  ViewGridIcon,
  XIcon,
} from '@heroicons/react/outline'
import { Link } from "react-router-dom";
import { ChevronDownIcon } from '@heroicons/react/solid'
import { useTheme } from '../providers/ThemeProvider'

import Cta from "./Cta"

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function SimplifiedHeader(props) {
  var showLogin = props.showLogin || false;
  var showRegister = props.showRegister || false;

  const [theme, themeDispatch] = useTheme();

  return (
    <Popover className={classNames("relative", (theme.headerDark ? 'dark' : ''))} style={{height: "12vh"}} >
      <div className="absolute z-30 pointer-events-none" aria-hidden="true" />
      <div className="relative z-20i h-full">
        <div className="mx-auto h-full flex justify-between items-center px-4 py-4 md:py-5 md:px-8 md:justify-start md:space-x-10">
          <div>
            <a href="/" className="flex">
              <span className="sr-only">Workflow</span>
              { theme.logo &&
                <div className="flex flex-row space-x-6">
                  <div className="pr-6 border-convoy-blue dark:border-white border-r-2">
                    <img
                      className="w-auto h-logo-mobile lg:h-logo dark:brightness-0 dark:invert"
                      src={ !theme.headerDark ? "/images/logo.png" : "/images/logo_dark.png"}
                      alt="The Convoy Logo"
                    />
                  </div>
                  <div className="">
                    <img
                      className="w-auto h-logo-mobile lg:h-logo"
                      src={theme.logo}
                      alt={theme.logoAlt}
                    />
                  </div>
                </div>
              }
              { !theme.logo &&
                <img
                  className="w-auto h-logo-mobile lg:h-logo"
                  src="/images/logo.png"
                  alt="The Convoy Logo"
                />
              }
            </a>
    {/*
            <a href="/" className="flex">
              <span className="sr-only">The Convoy</span>
              <img
                className="max-h-24 w-24 sm:w-36"
                src="/images/logo.png"
                alt=""
              />
            </a>
    */}
          </div>
          <div className="md:flex-1 md:flex md:items-center md:justify-between">
            <Popover.Group as="nav" className="hidden md:flex md:space-x-10">
            </Popover.Group>
            <div className="flex items-center md:ml-12">
            { showLogin && 
              <a href="/login" className="text-subtitle-mobile md:text-subtitle font-medium text-black dark:text-white border-b-2 border-transparent hover:border-blue-500">
                Log In
              </a>
            }
            { showRegister && 
                <Cta label="Register" href="/register" style="small-style-2" />
            }

            </div>
    
          </div>
        </div>
      </div>

    </Popover>
  )
}

export default SimplifiedHeader;
